<script setup lang="ts">
import { computed, DefineComponent, onMounted, PropType, watch } from 'vue';
import { FilterOptionModalItem, OptionItemModel } from '../../../models';
import { OptionFilterEnum } from '../../../enums';
import FilterGlobalStatusesParameter from './FilterGlobalStatusesParameter.vue';
import { TirCheckbox, TirPmRadio } from 'tir-components';
import FilterProjectsParameter from './FilterProjectsParameter.vue';
import { TaskParameterTypeEnum } from '@/components/task-parameter';
import { ref } from 'vue';

/**Параметры */
const props = defineProps({
  /**Тип параметра */
  typeParameter: {
    type: Object as PropType<TaskParameterTypeEnum>,
  },
  /**Отображаемый компонент */
  showComponent: {
    type: Object as () => DefineComponent<{}, {}, any>,
    required: true,
  },
  /**Данная опции фильтра */
  item: {
    type: Object as PropType<OptionItemModel>,
    required: true,
  },
  /**Опция */
  option: {
    type: Object as PropType<OptionFilterEnum>,
    required: true,
  },
  /**Скрытые элементы */
  hiddenElements: {
    type: Object as PropType<OptionItemModel[]>,
  },
  /**Данные опции фильтра */
  filterOptionData: {
    type: Object as PropType<FilterOptionModalItem>,
    required: true,
  },
});
/**События */
const emit = defineEmits<{
  /**Переключение чекбокса элемента*/
  toggleItem: [item: OptionItemModel, type: OptionFilterEnum, isMultiSelect: boolean];
}>();

/**Состояние радиокнопки */
const isSelectRadio = computed({
  get: () => {
    return props.filterOptionData.SelectedOptions.some((elem) => elem.Id == props.item.Id) ? 1 : 0;
  },
  set: () => {
    emit('toggleItem', props.item, props.option, false);
  },
});
/**Состояние чек бокса */
const isSelectCheckBox = computed<boolean>({
  get: () => {
    return (
      props.filterOptionData.SelectedOptions.some((elem) => elem.Id === props.item.Id) ||
      props.filterOptionData.HiddenElements[props.option]?.some((elem) => elem.Id === props.item.Id)
    );
  },
  set: () => {
    emit('toggleItem', props.item, props.option, true);
  },
});
</script>
<template>
  <div class="filter-parameter__item">
    <TirPmRadio v-if="!filterOptionData.isMultiSelect" v-model="isSelectRadio" :value="1" />
    <TirCheckbox v-else v-model="isSelectCheckBox" />
    <component
      :is="showComponent"
      :type="typeParameter"
      :item="item"
      :selectedOptionsFilter="filterOptionData.SelectedOptions"
    />
  </div>
</template>
<style scoped lang="scss">
.filter-parameter {
  &__item {
    display: flex;
    align-items: center;
    gap: 0.75rem;
  }
}
</style>
